<template>
  <div class="home">
    <div class="pc">
      <!-- 头部导航 -->
      <div
        :class="[
          'home-header justify-center',
          isAddScrollNav ? 'scrollNav' : '',
        ]"
      >
        <nav class="home-nav justify-between items-center">
          <a href="#">
            <div class="home-nav-logo"></div>
          </a>

          <!-- @mouseenter="addCurentClassHandle(1)"
        @mouseleave="removeCurentClassHandle(1)"
                  <li
            :class="
            `home-nav-menu-item ${
              isAddCurentClass[0] ? 'home-nav-menu-curent-item' : ''
            }`
          "
          >
          -->
          <ul class="home-nav-menu justify-between items-center">
            <li
              :class="[
                'home-nav-menu-item',
                curHome ? 'home-nav-menu-curent-item' : '',
              ]"
              @click="
                curHome = true
                curServer = false
                curAboutUs = false
                navHandleClick('#')
              "
            >
              <span class="nav-menu-item-text">首页</span>
            </li>
            <li
              :class="[
                'home-nav-menu-item',
                curServer ? 'home-nav-menu-curent-item' : '',
              ]"
              @click="
                curHome = false
                curServer = true
                curAboutUs = false
                navHandleClick('#server')
              "
            >
              <span class="nav-menu-item-text">产品服务</span>
            </li>
            <li
              :class="[
                'home-nav-menu-item',
                curAboutUs ? 'home-nav-menu-curent-item' : '',
              ]"
              @click="
                curHome = false
                curServer = false
                curAboutUs = true
                navHandleClick('#about-us')
              "
            >
              <span class="nav-menu-item-text">关于我们</span>
            </li>
          </ul>
        </nav>
      </div>
      <div class="content">
        <!-- banner部分 -->
        <div class="home-mode banner justify-center items-center flex-column">
          <div :class="['banner-bg', isAddBannerAni ? 'zoomInOutStyle' : '']">
            <img src="../assets/images/banner.png" alt />
          </div>
          <div
            class="goods-text justify-center items-center flex-column animation"
          >
            <h5 @click="gotonext">科技点亮生活</h5>
            <p>Breaking the barriers, connecting the lives</p>
          </div>
        </div>
        <div id="server" class="home-mode home-server homeServer">
          <div class="home-server-main">
            <div class="home-server-bg">
              <div class="home-server-bg-items"></div>
              <div class="home-server-bg-items"></div>
            </div>
            <div
              class="home-server-text justify-center items-center flex-column"
            >
              <h5
                class="title animate scroll-hidden"
                data-ani="scrollVisible"
                data-pos="homeServer"
              >
                产品服务
              </h5>
              <p
                class="sub-title animate scroll-hidden"
                data-ani="scrollVisible"
                data-pos="homeServer"
              >
                PRODUCT SERVICE
              </p>
            </div>
            <ul class="home-server-imgs justify-center items-center">
              <li
                class="items animate scroll-hidden"
                data-ani="scrollVisible"
                data-pos="homeServer"
                v-for="(item, index) in serverImgData"
                :key="index"
              >
                <div
                  class="items-content items-center justify-center flex-column"
                  :style="`backgroundImage: url(${item.url})`"
                >
                  <div class="items-content-main flex-column items-center">
                    <span
                      class="items-content-icon"
                      :style="`backgroundImage: url(${item.iconUrl})`"
                    ></span>
                    <span class="items-content-text">{{ item.text }}</span>
                    <span class="items-content-line"></span>
                  </div>
                </div>
                <div class="items-cover"></div>
              </li>
            </ul>
          </div>
        </div>
        <div id="about-us" class="home-mode aboutUs home-about-us">
          <ul class="home-about-us-bg justify-start items-start">
            <li class="item first-item"></li>
            <li class="item"></li>
            <li class="item"></li>
            <li class="item"></li>
            <li class="item"></li>
            <li class="item"></li>
            <li class="item"></li>
            <li class="item"></li>
            <li class="item last-item"></li>
          </ul>
          <div
            class="home-about-us-content justify-center items-center flex-column"
          >
            <div class="about-us-title">
              <h5
                class="title animate scroll-hidden"
                data-ani="scrollVisible"
                data-pos="aboutUs"
              >
                关于我们
              </h5>
              <p
                class="sub-title animate scroll-hidden"
                data-ani="scrollVisible"
                data-pos="aboutUs"
              >
                ABOUT US
              </p>
            </div>
            <div
              class="about-us-texts animate scroll-hidden"
              data-ani="scrollVisible"
              data-pos="aboutUs"
              @click="gotonext"
            >
              众泽睿诚是一家提供数字化生活服务的科技公司。以数据技术、人工智能等前沿技术为背景，专注于研发模块化的业务中台，建立高可用的风控核心体系、输出精准的业务分析报告，为个人、中小微企业，政府机构提供数字化生活服务，为个性化业务场景提供互联网解决能力。
            </div>
          </div>
        </div>
        <div class="home-mode home-info">
          <div class="home-info-content items-center flex-column">
            <div
              class="home-info-logo animate scroll-hidden"
              data-ani="scrollVisible"
            ></div>
            <div class="flex-column items-center" style="width:1200px;">
              <div
                class="home-info-name animate scroll-hidden"
                data-ani="scrollVisible"
              >
                北京众泽睿诚科技有限公司
              </div>
              <div class="home-info-text justify-center items-center">
                <div
                  class="home-info-text-item email flex-column animate scroll-hidden"
                  data-ani="scrollVisible"
                >
                  <span class="title">邮箱：</span>
                  <span class="text">business@zzrc.tech</span>
                </div>
                <div
                  class="home-info-text-line animate scroll-hidden"
                  data-ani="scrollVisible"
                ></div>
                <div
                  class="home-info-text-item address flex-column animate scroll-hidden"
                  data-ani="scrollVisible"
                >
                  <span class="title">地址：</span>
                  <span class="text"
                    >北京市海淀区高梁桥斜街42号院1号楼7层1-717</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer justify-center items-center flex-column">
        <div class="footer-text">
          <span>Copyright © 2020 ZZRC Co., Ltd All Rights Reserved.</span>
        </div>
        <div class="footer-text justify-center items-center">
          <a
            class="left-text icp-number"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            >京ICP备20019906号</a
          >
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032145"
          >
            <img src="../assets/images/pc.png" />
            <span>京公网安备 11010802032145号</span>
          </a>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap-logo"></div>
      <div class="wrap-banner justify-center items-center">
        <div class="wrap-banner-text flex-column">
          <h5 class="wrap-banner-text-title">科技点亮生活</h5>
          <span class="wrap-banner-text-subtitle"
            >Breaking the barriers，connecting the lives</span
          >
        </div>
      </div>
      <div class="wrap-serve flex-column justify-center items-center">
        <div class="wrap-serve-text">
          <h5 class="wrap-serve-text-title">产品服务</h5>
          <span class="wrap-serve-text-subtitle">PRODUCT SERVICE</span>
        </div>
        <ul class="wrap-serve-imgs flex-column">
          <li class="wrap-serve-imgs-items">
            <div class="wrap-serve-imgs-cover"></div>
            <div
              class="wrap-serve-imgs-content flex-column justify-center items-center"
            >
              <span class="wrap-serve-imgs-icon"></span>
              <span class="wrap-serve-imgs-title">政策分析</span>
            </div>
          </li>
          <li class="wrap-serve-imgs-items">
            <div class="wrap-serve-imgs-cover"></div>
            <div
              class="wrap-serve-imgs-content flex-column justify-center items-center"
            >
              <span class="wrap-serve-imgs-icon"></span>
              <span class="wrap-serve-imgs-title">市场调研</span>
            </div>
          </li>
          <li class="wrap-serve-imgs-items">
            <div class="wrap-serve-imgs-cover"></div>
            <div
              class="wrap-serve-imgs-content flex-column justify-center items-center"
            >
              <span class="wrap-serve-imgs-icon"></span>
              <span class="wrap-serve-imgs-title">行业创新</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="wrap-about-us flex-column justify-center items-center">
        <ul class="wrap-about-us-bg">
          <li class="about-us-bg-item"></li>
          <li class="about-us-bg-item"></li>
          <li class="about-us-bg-item"></li>
          <li class="about-us-bg-item"></li>
          <li class="about-us-bg-item"></li>
        </ul>
        <div class="wrap-about-us-text flex-column">
          <h5 class="wrap-about-us-title">关于我们</h5>
          <span class="wrap-about-us-subtitle">ABOUT US</span>
        </div>
        <a
          href="https://ebjdev.zzrcer.com/litchi"
          class="wrap-about-us-content"
        >
          众泽睿诚是一家提供数字化生活服务的科技公司。以数据技术、人工智能等前沿技术为背景，专注于研发模块化的业务中台，建立高可用的风控核心体系、输出精准的业务分析报告，为个人、中小微企业，政府机构提供数字化生活服务，为个性化业务场景提供互联网解决能力。
        </a>
      </div>
      <div class="wrap-company-info">
        <div class="wrap-company-logo"></div>
        <div class="wrap-company-content flex-column">
          <div class="wrap-company-name">北京众泽睿诚科技有限公司</div>
          <div class="wrap-company-email wrap-company-text flex-column">
            <span class="title">邮箱：</span>
            <span class="text">business@zzrc.tech</span>
          </div>
          <div class="wrap-company-addres wrap-company-text flex-column">
            <span class="title">地址：</span>
            <span @click="gotonext" class="text"
              >北京市海淀区高梁桥斜街42号院1号楼7层1-717</span
            >
          </div>
        </div>
      </div>
      <div class="wrap-company-footer flex-column items-center justify-center">
        <span class="wrap-company-footer-text"
          >Copyright © 2020 ZZRC Co., Ltd All Rights Reserved.</span
        >
        <a
          class="wrap-company-footer-text icp-number"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          >京ICP备20019906号</a
        >
        <a
          class="items-center wrap-company-footer-text"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032145"
          style="display:inline-block;text-decoration:none;height:22px;line-height:22px;"
        >
          <img src="../assets/images/wrap_imgs/yd.png" />
          <span>京公网安备 11010802032145号</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      isMobile: false,
      isAddScrollNav: false,
      isAddBannerAni: false,
      curHome: true,
      curServer: false,
      curAboutUs: false,
      timer: null,
      screenWidth: null,
      serverImgData: [
        {
          url: require('../assets/images/server-tea.png'),
          iconUrl: require('../assets/images/server-row.png'),
          text: '政策分析',
        },
        {
          url: require('../assets/images/server-computer.png'),
          iconUrl: require('../assets/images/server-box.png'),
          text: '市场调研',
        },
        {
          url: require('../assets/images/server-man.png'),
          iconUrl: require('../assets/images/server-icon.png'),
          text: '行业创新',
        },
      ],
    }
  },
  created() {
    this.addBannerAni()
    this.$nextTick(() => {
      this.isAddBannerAni = !this.isAddBannerAni
      this.isMobileFn()
    })
  },
  deactivated() {
    // clearTimeout(this.timer);
  },
  methods: {
    isMobileFn() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    addBannerAni() {
      this.timer = setInterval(() => {
        this.isAddBannerAni = !this.isAddBannerAni
      }, 10000)
    },
    navHandleClick(path) {
      location.href = path
    },
    handleNav() {
      let vh = $('.banner').height()
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.isAddScrollNav = vh < top ? true : false
    },
    gotonext() {
      location.href = 'https://ebjdev.zzrcer.com/test'
    },
    handleAnimate() {
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let vh = document.documentElement.clientHeight
      let dom = document.querySelectorAll('.animate')
      ;[].slice.call(dom).forEach((v) => {
        let pos = $.trim(v.dataset.pos)
        let vTop = v.offsetTop
        let vParent = pos ? $(v).parents('.' + pos) : ''
        vTop = vParent ? vTop + vParent.offset().top : vTop
        vTop = vTop + $(v).height() / 4
        if (top + vh > vTop) {
          var delay = v.dataset.delay
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1
            v.classList.add(v.dataset.ani)
          }
        }
        // else {
        //   v.classList.remove(v.dataset.ani);
        //   v.style.opacity = 0;
        // }
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.handleAnimate() //初始化第一次加载时在视口内就执行动画
      // this.handleResize();
      addEventListener('scroll', this.handleAnimate)
      addEventListener('scroll', this.handleNav)
      // addEventListener("resize", this.handleResize);
    })
  },
  destroyed() {
    removeEventListener('scroll', this.handleAnimate) //避免影响其他页面
    removeEventListener('scroll', this.handleNav)
    // removeEventListener("resize", this.handleResize);
  },
}
</script>
<style lang="stylus" scoped>
@media screen and (min-width: 755px) {
  html {
    font-size: 12px;
  }

  .wrap {
    display: none;
  }

  .pc {
    display: block;
  }
}

@media screen and (max-width: 755px) {
  html {
    font-size: 100px !important;
  }

  .wrap {
    display: block;
    background-color: #fff;
    box-sizing: border-box;
  }

  .pc {
    display: none;
  }
}

.home {
  position: relative;

  .pc {
    // animate classs
    .animate {
      transition: all, 1s ease-in-out;
    }

    .scroll-in-out {
      transition: all, 1s ease-in-out;
    }

    .scroll-hidden {
      opacity: 0.8;
      transform: translateY(30px);
    }

    .scrollVisible {
      transform: translateY(0);
    }

    .goods-text, .home-server-main, .home-about-us, .home-info, .footer {
      min-width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
    }

    .home-server-main, .home-about-us, .home-info {
      min-width: 1200px !important;
    }

    .home-header {
      width: 100%;
      // min-width: 755px;
      height: 80px;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 99;
      background-color: #ffffff;

      &.scrollNav {
        box-shadow: 0px 5px 16px 0px rgba(242, 242, 242, 1);
      }

      .home-nav {
        width: 1200px;
        height: 80px;
        background-color: #ffffff;
        // box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
        z-index: 3;

        .home-nav-logo {
          width: 164px;
          height: 40px;
          text-align: center;
          background-image: url('../assets/images/logo.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }

        .home-nav-menu {
          .home-nav-menu-item {
            // height: 68px;
            font-size: 16px;
            color: #1D2544;
            text-align: center;
            padding-bottom: 10px;
            margin: 32px 0 20px;
            box-sizing: border-box;
            -webkit-box-sizing: border-box;
            border-bottom: 2px solid #fff;
            cursor: pointer;
            white-space: nowrap;

            // letter-spacing: 2px;
            .nav-menu-item-text {
              pointer-events: none; // 解决mouseenter一直闪烁的bug
            }
          }

          .home-nav-menu-item + .home-nav-menu-item {
            margin-left: 60px;
          }

          .home-nav-menu-item:hover {
            color: rgba(71, 119, 255, 1) !important;
            // border-bottom: 2px solid rgba(71, 119, 255, 1);
          }

          .home-nav-menu-item.home-nav-menu-curent-item {
            font-weight: 600;
            color: rgba(71, 119, 255, 1) !important;
            border-bottom: 2px solid rgba(71, 119, 255, 1);
          }
        }
      }
    }

    .content {
      width: 100%;
      margin-top: 80px;

      .banner {
        width: 100%;
        min-width: 1200px;
        position: relative;
        overflow: hidden;

        .banner-bg {
          width: 100%;
          // min-width: 1920px;
          height: 75vh;
          // padding-bottom: 41.67%;
          // background-image: url('../assets/images/banner.png');
          // background-size: cover;
          // background-position: center;
          overflow: hidden;

          &.zoomInOutStyle {
            img {
              transform: translate3d(0, 0, 0) scale(1.2);
              -webkit-transform: translate3d(0, 0, 0) scale(1.2);
            }
          }

          img {
            width: 100%;
            height: 100%;
            min-width: 1200px;
            vertical-align: middle;
            transform: translate3d(0, 0, 0) scale(1);
            -webkit-transform: translate3d(0, 0, 0) scale(1);
            transition: transform 10s linear;
            -webkit-transition: transform 10s linear;
          }
        }

        // margin-bottom: 80px;
        .goods-text {
          width: 100%;
          // min-width: 1920px!important;
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;

          // margin: auto;
          h5 {
            height: 80px;
            line-height: 80px;
            font-size: 80px;
            font-weight: 500;
            color: #ffffff;
            margin-bottom: 50px;
            white-space: nowrap;
          }

          p {
            height: 30px;
            line-height: 30px;
            font-size: 30px;
            color: #ffffff;
            letter-spacing: 2px;
            font-family: Arial;
            white-space: nowrap;
          }
        }
      }

      .home-server {
        width: 100%;
        height: 1124px;
        margin-bottom: 0;

        .home-server-bg {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;

          .home-server-bg-items:nth-child(1) {
            width: 490px;
            height: 490px;
            border-radius: 490px;
            overflow: hidden;
            position: absolute;
            left: -279px;
            bottom: 48px;
            background: linear-gradient(180deg, rgba(253, 253, 253, 1) 0%, rgba(246, 246, 246, 1) 100%);
            -webkit-background: linear-gradient(180deg, rgba(253, 253, 253, 1) 0%, rgba(246, 246, 246, 1) 100%);
          }

          .home-server-bg-items:nth-child(2) {
            width: 454px;
            height: 454px;
            border-radius: 454px;
            overflow: hidden;
            background: linear-gradient(180deg, rgba(253, 253, 253, 1) 0%, rgba(246, 246, 246, 1) 100%);
            -webpack-background: linear-gradient(180deg, rgba(253, 253, 253, 1) 0%, rgba(246, 246, 246, 1) 100%);
            position: absolute;
            top: 255px;
            right: -227px;
          }
        }

        .home-server-text {
          padding: 200px 0 121px;

          .title {
            line-height: 60px;
            font-size: 60px;
            font-weight: 500;
            color: #1D2544;
            letter-spacing: 5px;
            margin-bottom: 28px;
          }

          .sub-title {
            line-height: 25px;
            font-size: 25px;
            color: #A0A2AD;
            letter-spacing: 17px;
            font-family: Arial;
          }
        }

        .home-server-imgs {
          .items {
            width: 340px;
            height: 440px;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;

            &:hover {
              .items-cover {
                transition: all 0.4s;
                background-color: rgba(71, 119, 255, 0.89);
              }

              .items-content-line {
                width: 113px;
                height: 6px;
                background-color: #ffffff;
                margin-top: 30px;
              }

              .items-content-main {
                padding: 110px 0 153px;
                transition: all 0.4s;
              }

              .items-content-icon {
                margin-bottom: 48px !important;
              }
            }
          }

          .items+.items {
            margin-left: 90px;
          }

          .items-cover {
            width: 340px;
            height: 440px;
            overflow: hidden;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(29, 37, 68, 0.6);
          }

          .items-content {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;

            .items-content-main {
              width: 100%;
              height: 100%;
              overflow: hidden;
              position: relative;
              z-index: 3;
              padding: 134px 0 149px;

              .items-content-icon {
                width: 66px;
                height: 67px;
                margin-bottom: 60px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
              }

              .items-content-text {
                line-height: 30px;
                font-size: 30px;
                color: #ffffff;
              }
            }
          }
        }
      }

      .home-about-us {
        width: 100%;
        height: 760px;
        background-color: #4777FF;
        position: relative;
        margin-bottom: 0;

        .home-about-us-bg {
          height: 100%;
          margin: 0 162px;

          // border-left: 1px solid rgba(255, 255, 255, 0.2);
          // border-right: 1px solid rgba(255, 255, 255, 0.2);
          .item {
            flex: 1;
            -webkit-flex: 1;
            min-width: 220px;
            height: 100%;
            overflow: hidden;
          }

          .first-child {
            flex: 1;
            -webkit-flex: 1;
            min-width: 220px;
            height: 100%;
            border-left: 1px solid rgba(255, 255, 255, 0.1);
          }

          .first-item {
            border-left: 1px solid rgba(255, 255, 255, 0.1);
          }

          .last-item {
            border-left: 1px solid rgba(255, 255, 255, 0.1);
          }

          .item+.item {
            border-left: 1px solid rgba(255, 255, 255, 0.1);
          }
        }

        .home-about-us-content {
          width: 100%;
          height: 100%;
          overflow: hidden;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;

          .about-us-title {
            margin-bottom: 95px;

            .title {
              font-size: 60px;
              line-height: 60px;
              color: #ffffff;
              font-weight: 500;
              letter-spacing: 5px;
              margin-bottom: 28px;
            }

            .sub-title {
              font-size: 25px;
              line-height: 25px;
              color: #B1C5FF;
              letter-spacing: 17px;
              font-family: Arial;
            }
          }

          .about-us-texts {
            width: 953px;
            font-size: 20px;
            line-height: 50px;
            color: #fff;
            text-align: left;
          }
        }
      }

      .home-info {
        width: 100%;
        height: 979px;
        overflow: hidden;
        background-color: #fff;
        background-image: url('../assets/images/home-info-bg.png');
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: center center;

        .home-info-content {
          width: 100%;
          height: 100%;

          .home-info-logo {
            width: 226px;
            height: 226px;
            margin: 260px 0 100px;
            background-image: url('../assets/images/home-info-logo.png');
            background-size: 80% 80%;
            background-repeat: no-repeat;
            background-position: center;
          }

          .home-info-name {
            font-size: 20px;
            height: 20px;
            color: #1D2544;
            letter-spacing: 50px;
            padding-left: 50px;
          }

          .home-info-text {
            width: 100%;
            margin-top: 133px;

            .home-info-text-item + .home-info-text-item {
              // border-left: 1px solid #979797;
            }

            .home-info-text-line {
              width: 1px;
              height: 40px;
              background-color: #DCDCDC;
              overflow: hidden;
            }

            .email {
              font-family: Arial;
            }

            .email, .address {
              flex: 1;
              -webkit-flex: 1;
            }

            .title {
              font-size: 20px;
              line-height: 28px;
              color: #1D2544;
              margin-bottom: 6px;
              // text-align: left;
            }

            .text {
              font-size: 20px;
              line-height: 30px;
              color: #1D2544;
            }
          }
        }
      }
    }

    .footer {
      width: 100%;
      height: 130px;
      background-color: #131A37;
      .icp-number{
        cursor pointer
      }
      .icp-number:hover{
        color #ffffff
      }
      .footer-text {
        font-size: 16px;
        line-height: 22px;
        color: rgba(255, 255, 255, 0.5);
        white-space: nowrap;
        .left-text{
          margin-right 40px
        }
        span{
          display inline-block
          font-size: 16px;
          line-height: 22px;
          color: rgba(255, 255, 255, 0.5);
          white-space: nowrap;
          font-family: Arial;
        }
        a {
          display block
          font-size: 16px;
          text-decoration:none;
          height:16px;
          line-height 22px
          color: rgba(255, 255, 255, 0.5);
          white-space: nowrap;
          font-family: Arial;
          img {
            width 16px
            height 16px
            margin-right 10px
            margin-top -1px
            vertical-align top
          }
          span {
            vertical-align top
            line-height 16px
          }
          &:hover{
            span {
              color #ffffff
            }
          }
        }
      }
      .footer-text + .footer-text {
        margin-top 17px
      }
    }
  }

  .wrap {
    width: 100%;
    height: auto;
    position: relative;
    overflow-x: hidden;

    .wrap-logo {
      width: 125px;
      height: 30px;
      background-image: url('../assets/images/wrap_imgs/wrap_logo.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      position: absolute;
      top: 25px;
      left: 20px;
      z-index: 99;
    }

    .wrap-banner {
      width: 100%;
      height: 450px;
      overflow: hidden;
      // padding-bottom: 120%;
      position: relative;
      background-image: url('../assets/images/wrap_imgs/wrap_banner.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;

      .wrap-banner-text {
        .wrap-banner-text-title {
          height: 80px;
          line-height: 80px;
          font-size: 40px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
        }

        .wrap-banner-text-subtitle {
          height: 30px;
          line-height: 30px;
          font-size: 15px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          font-family: Arial;
          letter-spacing: 0.015rem;
        }
      }
    }

    .wrap-serve {
      width: 100%;
      box-sizing: border-box;
      padding: 80px 20px;

      .wrap-serve-text {
        padding-bottom: 40px;

        .wrap-serve-text-title {
          height: 30px;
          line-height: 30px;
          font-size: 30px;
          font-weight: 500;
          color: rgba(29, 37, 68, 1);
          letter-spacing: 2px;
          margin-bottom: 10px;
        }

        .wrap-serve-text-subtitle {
          height: 15px;
          font-size: 15px;
          line-height: 15px;
          font-weight: 400;
          font-family: Arial;
          color: rgba(160, 162, 173, 1);
          letter-spacing: 3px;
        }
      }

      .wrap-serve-imgs {
        .wrap-serve-imgs-items {
          width: 335px;
          height: 230px;
          // // width: 89.3%;
          // height: 14.5%;
          position: relative;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;

          &:nth-child(1) {
            background-image: url('../assets/images/wrap_imgs/wrap_serve_1.png');

            .wrap-serve-imgs-icon {
              background-image: url('../assets/images/wrap_imgs/wrap_row.png');
            }
          }

          &:nth-child(2) {
            background-image: url('../assets/images/wrap_imgs/wrap_serve_2.png');

            .wrap-serve-imgs-icon {
              background-image: url('../assets/images/wrap_imgs/wrap_box.png');
            }
          }

          &:nth-child(3) {
            background-image: url('../assets/images/wrap_imgs/wrap_serve_3.png');

            .wrap-serve-imgs-icon {
              background-image: url('../assets/images/wrap_imgs/wrap_icon.png');
            }
          }

          .wrap-serve-imgs-cover {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: rgba(13, 18, 37, 0.7);
          }
        }

        .wrap-serve-imgs-items+.wrap-serve-imgs-items {
          margin-top: 40px;
        }

        .wrap-serve-imgs-content {
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 1;

          .wrap-serve-imgs-icon {
            width: 60px;
            height: 60px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
          }

          .wrap-serve-imgs-title {
            height: 20px;
            font-size: 20px;
            color: rgba(255, 255, 255, 1);
            line-height: 20px;
            margin-top: 30px;
          }
        }
      }
    }

    .wrap-about-us {
      width: 100%;
      height: 545px;
      box-sizing: border-box;
      padding: 80px 40px;
      background-color: #4777FF;
      position: relative;

      .wrap-about-us-bg {
        display: flex;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: 0 auto;

        .about-us-bg-item {
          width: 100px;
          height: 100%;

          &:nth-child(1) {
            width: 45px !important;
          }

          &:last-child {
            width: 45px !important;
          }
        }

        .about-us-bg-item + .about-us-bg-item {
          border-left: 1px solid rgba(255, 255, 255, 0.1);
        }
      }

      .wrap-about-us-title {
        height: 30px;
        line-height: 30px;
        font-size: 30px;
        font-weight: 500;
        color: #fff;
        letter-spacing: 2px;
        margin-bottom: 20px;
      }

      .wrap-about-us-subtitle {
        height: 15px;
        line-height: 15px;
        font-size: 15px;
        font-family: Arial;
        color: #fff;
        letter-spacing: 3px;
      }

      .wrap-about-us-content {
        height: 280px;
        line-height: 40px;
        margin-top: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        // text-align: left;
        text-align-last: justify;
        text-align: justify;
        text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
      }
    }

    .wrap-company-info {
      width: 100%;
      height: 644px;
      position: relative;
      background-color: #fff;
      background-image: url('../assets/images/wrap_imgs/wrap_info_bg.png');
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center center;

      .wrap-company-logo {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 120px;
        height: 120px;
        margin: 162px auto 73px;
        background-image: url('../assets/images/wrap_imgs/wrap_info_logo.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center center;
      }

      .wrap-company-content {
        width: 100%;
        position: relative;
        top: 347px;
        left: 0;
      }

      .wrap-company-email .text {
        font-weight: Arial;
      }

      .wrap-company-name {
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        color: #A0A2AD;
        letter-spacing: 10px;
        margin-bottom: 60px;
        padding-left: 10px;
      }

      .wrap-company-text {
        width: 100%;
        box-sizing: border-box;
        padding: 0 35px;
        text-align: left;

        .title {
          height: 20px;
          font-size: 16px;
          font-weight: 500;
          color: #1D2544;
          line-height: 22px;
        }

        .text {
          height: 20px;
          line-height: 20px;
          margin-top: 17px;
          font-size: 16px;
          color: #1D2544;
        }
      }

      .wrap-company-addres {
        margin-top: 38px;
      }
    }

    .wrap-company-footer {
      width: 100%;
      height: 123px;
      background-color: #131A37;
      .icp-number{
        cursor pointer
      }
      .icp-number:hover{
        color #ffffff
      }
      .wrap-company-footer-text {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        line-height: 25px;

        &:nth-child(2) {
          font-family: Arial;
        }
        &:last-child {
          margin-top 4px
        }
        img {
          width 14px
          height 14px
          margin -3px 5px 0 0
        }
      }
    }
  }
}

.zoomIn {
  animation: zoomIn 1s;
}

.fadeInUpBig {
  animation: fadeInUpBig 1s;
}

.rollIn {
  animation: rollIn 1s;
}

.slideInRight {
  animation: slideInRight 1s;
}

.slideIn {
  animation: slideIn 1s;
}

.bounceInLeft {
  animation: bounceInLeft 2s ease-in;
}

.bounceInRight {
  animation: bounceInRight 2s ease-in;
}

.slideInUp {
  animation: slideInUp 1s ease-in;
}

@keyframes moveAnimate {
  0% {
    transform: translateY(20px);
    opacity: 0.8;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes moveAnimate {
  0% {
    transform: translateY(20px);
    opacity: 0.8;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animation {
  animation: moveAnimate 2s;
  -webkit-animation: moveAnimate 2s; /* Safari 和 Chrome */
}
</style>
